import { compressPDF, createBuySummaryPDF } from "helpers/pdf";

export const handleCompressPDF = async (file, blob) => {
    let response = null;
	let endpoint = `/misc/compressFile`;
    let payload = {
        "fileName": file.name,
        "base64Content": blob.split(",")[1],
        "fileExt":  file.name.split(".").pop().toLowerCase()
    }
    
    
	response = await compressPDF({ endpoint, payload });
    
    return response;
};

export const handleCreateBuySummaryPDF= async (policy, quote,paymentData, oldPolicyNumber) => {
    let response = null;
    let endpoint = `/misc/buySummaryPDF`;
    let payload = {
policy: policy,
quote: quote,
payment: paymentData,
oldPolicyNumber
}
    
    
    response = await createBuySummaryPDF({ endpoint, payload });
    
    return response;
};